<template>
  <div
    ref="mapContainer"
    class="yandex-map-container"
    :class="{
      'yandex-map-container--static': !interactive,
      'yandex-map-container--fill': fill,
    }"
    :style="containerStyle"
  ></div>
</template>

<script>
  export default {
    name: "YandexMap",
    props: {
      /** false: карта как картинка — без перетаскания, зума и колесика */
      interactive: {
        type: Boolean,
        default: true,
      },
      /** true: зум колесиком/скроллом (в embed-конструкторе). Перетаскание карты не зависит от этого флага. */
      scrollZoom: {
        type: Boolean,
        default: true,
      },
      /** Высота embed (px). На главной — 663. */
      height: {
        type: [Number, String],
        default: 663,
      },
      /** Растянуть iframe на 100% родителя (для карточек отделений). */
      fill: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      mapHeight() {
        const n = parseInt(this.height, 10);
        return Number.isFinite(n) && n > 0 ? n : 663;
      },
      containerStyle() {
        return {
          '--ymap-height': `${this.mapHeight}px`,
        };
      },
    },
    watch: {
      mapHeight(next, prev) {
        if (next !== prev) {
          this.initConstructorMap();
        }
      },
    },
    mounted() {
      this.initConstructorMap();
    },
    beforeDestroy() {
      if (this.mapObserver) {
        this.mapObserver.disconnect();
        this.mapObserver = null;
      }
    },
    methods: {
      forceMapWidth() {
        if (!this.$refs.mapContainer) {
          return;
        }
        const mapRoot = this.$refs.mapContainer.querySelector("ymaps");
        if (mapRoot) {
          mapRoot.style.width = "100%";
          mapRoot.style.maxWidth = "100%";
        }
        if (this.fill) {
          const iframe = this.$refs.mapContainer.querySelector("iframe");
          if (iframe) {
            iframe.style.height = "100%";
          }
        }
      },
      initConstructorMap() {
        if (!this.$refs.mapContainer) {
          return;
        }
        if (this.mapObserver) {
          this.mapObserver.disconnect();
          this.mapObserver = null;
        }
        this.$refs.mapContainer.innerHTML = "";
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.charset = "utf-8";
        script.async = true;
        const scroll =
          this.interactive && this.scrollZoom ? "true" : "false";
        const h = this.mapHeight;
        script.src = `https://api-maps.yandex.ru/services/constructor/1.0/js/?um=constructor%3Ac12996e6d4dcd3856efea0ab02049bb399b515b4ade7db5e872ffde5250d5211&width=100%25&height=${h}&lang=ru_RU&scroll=${scroll}`;
        this.$refs.mapContainer.appendChild(script);

        this.mapObserver = new MutationObserver(() => {
          this.forceMapWidth();
        });
        this.mapObserver.observe(this.$refs.mapContainer, {
          childList: true,
          subtree: true,
        });
      },
    },
  };
</script>

<style scoped>
.yandex-map-container {
  width: 100%;
  max-width: 100%;
  line-height: 0;
  overflow: hidden;
}

.yandex-map-container--fill {
  height: 100%;
}

.yandex-map-container ::v-deep iframe {
  display: block;
  width: 100% !important;
  max-width: 100% !important;
  height: var(--ymap-height, 663px) !important;
}

.yandex-map-container--fill ::v-deep iframe {
  height: 100% !important;
  min-height: 100% !important;
}

.yandex-map-container ::v-deep ymaps {
  width: 100% !important;
  max-width: 100% !important;
}

.yandex-map-container ::v-deep .ymaps3x0--top-engine-container,
.yandex-map-container ::v-deep .ymaps3x0--main-engine-container,
.yandex-map-container ::v-deep canvas {
  width: 100% !important;
  max-width: 100% !important;
}

.yandex-map-container--static ::v-deep iframe,
.yandex-map-container--static ::v-deep ymaps,
.yandex-map-container--static ::v-deep canvas {
  pointer-events: none;
  user-select: none;
}

@media (max-width: 992px) {
  .yandex-map-container:not(.yandex-map-container--fill) ::v-deep iframe {
    height: min(460px, var(--ymap-height, 663px)) !important;
  }
}

@media (max-width: 600px) {
  .yandex-map-container:not(.yandex-map-container--fill) ::v-deep iframe {
    height: min(320px, var(--ymap-height, 663px)) !important;
  }
}

</style>
